const Logo = ({ compact = false }) => (
  <span className="flex items-center gap-3 select-none">
    <svg
      width={compact ? 30 : 34}
      height={compact ? 30 : 34}
      viewBox="0 0 64 64"
      fill="none"
      aria-hidden="true"
      className="shrink-0"
    >
      <rect width="64" height="64" rx="10" fill="#0F0F0F" stroke="#27272A" strokeWidth="2" />
      <path
        d="M13 45 L13 19 L26.5 37.5 L40 19 L40 45"
        stroke="#FFFFFF"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M50 9 C52.8 12.7 54.8 15.1 54.8 17.9 A4.8 4.8 0 1 1 45.2 17.9 C45.2 15.1 47.2 12.7 50 9 Z"
        fill="#E60000"
      />
    </svg>
    {!compact && (
      <span className="leading-none">
        <span className="font-display block text-xl font-bold tracking-[0.18em] text-white">
          MARR
        </span>
        <span className="block text-[9px] font-semibold tracking-[0.34em] text-zinc-400">
          MOBILE DETAILING
        </span>
      </span>
    )}
  </span>
);

export default Logo;
